import IconNavRight from '../../../assets/svg/IconNavRight';
import { neutralDark } from '../../../constants/color';
import { translate } from '../../../i18n';
import { getIsTW } from '../../../utils/countryInfo';
import { navigate } from '../../../utils/navigationService';
import routeUtils from '../../../utils/routes';
import { Tab } from '../../EventPage/type';
import { S } from './styles';

const iconSize = 12;

function navigateToEventPage(param: Tab) {
  return function () {
    navigate('EventPage', { currentTab: param });
  };
}

export default function ShortcutButtons() {
  if (!getIsTW()) {
    return null;
  }

  return (
    <S.BG>
      <S.Container testID="ShortcutButtons">
        <S.Button
          testID="DailyBonusBtn"
          onPress={navigateToEventPage(Tab.DailyBonus)}
          accessibilityRole="link"
          href={routeUtils.compileToPath('EventPage', {
            currentTab: Tab.DailyBonus,
          })}
        >
          <S.Image source={require('./assets/ic_shortcut_attendance.png')} />
          <S.Text>{translate('daily-bonus')}</S.Text>
          <IconNavRight size={iconSize} fillColor={neutralDark} />
        </S.Button>
        <S.Divider />
        <S.Button
          testID="CouponAreaBtn"
          onPress={navigateToEventPage(Tab.CouponArea)}
          accessibilityRole="link"
          href={routeUtils.compileToPath('EventPage', {
            currentTab: Tab.CouponArea,
          })}
        >
          <S.Image source={require('./assets/ic_shortcut_coupon.png')} />
          <S.Text>{translate('coupons-collection-area')}</S.Text>
          <IconNavRight size={iconSize} fillColor={neutralDark} />
        </S.Button>
      </S.Container>
    </S.BG>
  );
}
